import { useState } from 'react';
import { PopoverComponent } from '@arise-biodiversity/components';
import OverlappingDonutChart from './overlapping_donut_chart';

const KINGDOMS = {
  animalia: 'Animalia',
  plantae: 'Plantae',
  fungi: 'Fungi',
};

export default function KingdomsCharts({ data, loading }) {
  const [activeKingdom, setActiveKingdom] = useState(null);
  console.log("Loading: " + loading);
  if (loading) {
    return <div className="loading-state">Loading charts...</div>;
  }

  return (
    <div className='kingdom-charts' id='kingdom-charts'>
      <div className='charts-container'>
        {Object.keys(KINGDOMS).map((key) => {
          const kingdom = data[key];
          if (!kingdom) return null;

          const popoverContent = (
            <div className='charts-popover'>
              <div className='charts-popover-top'>
                <div className='charts-popover-top-left'>
                  <h1><a href={`/?q=${kingdom.displayName}&showfrom=kingdom`}>{kingdom.displayName}</a></h1>
                  <p>Total coverage: {kingdom.total}%</p>
                </div>
                <p className='total-species'>{new Intl.NumberFormat("nl-NL").format(kingdom.totalSpecies)} established species</p>
              </div>
              <div className='popover-value-container'>
                <p className='percent-value arise'>{kingdom.arise}%</p>
                <div>
                  <h3>ARISE <span>({new Intl.NumberFormat("nl-NL").format(kingdom.totalAriseSpecies)} species)</span></h3>
                  <p>References established* Dutch species belonging to the kingdom {kingdom.displayName} that are covered by ARISE consortium partners.</p>
                </div>
              </div>
              <div className='popover-value-container'>
                <p className='percent-value other'>{kingdom.other}%</p>
                <div>
                  <h3>Other organizations <span>({new Intl.NumberFormat("nl-NL").format(kingdom.totalOtherSpecies)} species)</span></h3>
                  <p>References of established* Dutch species belonging to the kingdom {kingdom.displayName} that are covered by other organisations inside and outside the Netherlands.</p>
                </div>
              </div>
              <div className='popover-value-container'>
                <p className='percent-value shared'>{kingdom.shared}%</p>
                <div>
                  <h3>Shared <span>({new Intl.NumberFormat("nl-NL").format(kingdom.totalSharedSpecies)} species)</span></h3>
                  <p>References of established* Dutch species belonging to the kingdom {kingdom.displayName} that are covered by both ARISE* and other organizations.<br />
                    This brings the <strong>total species uniquely covered by ARISE to {kingdom.uniqueArisePercent}%</strong>.</p>
                </div>
              </div>
              <p><strong>*</strong> with Occurrence Status 1a, 1b, 2a or 2b according to NSR.</p>
            </div>
          );

          return (
            <div key={key} style={{ marginBottom: 32, textAlign: 'center' }}>
              <OverlappingDonutChart
                size={160}
                arisePercent={kingdom.arise}
                otherPercent={kingdom.other}
                totalPercent={kingdom.total}
              />
              <div className='d-flex gap-1 align-items-center my-3'>
              <h3 className='chart-title'>{kingdom.displayName}</h3>
              <PopoverComponent
                trigger={
                  <button
                  className='chart-popover-trigger'
                  onClick={() => setActiveKingdom(activeKingdom === key ? null : key)}
                    aria-expanded={activeKingdom === key}
                    aria-controls={`popover-content-${key}`}
                  >
                  </button>
                }
                content={popoverContent}
                contentProps={{
                  side: "bottom",
                  align: "center",
                  sideOffset: 8,
                  avoidCollisions: true,
                  collisionPadding: 16,
                  id: `popover-content-${key}`,
                  style: {
                    borderRadius: "var(--border-radius-l)",
                    margin: "0 var(--spacing-l)"
                  }
                }}
                arrowProps={{ size: 'large' }}
              />
              </div>
              <a className='chart-link' href={`/?q=${kingdom.displayName}&showfrom=kingdom`}>View species</a>
            </div>
          );
        })}
      </div>

      <div className='charts-legenda'>
        <p className='legenda-item arise'>ARISE</p>
        <p className='legenda-item other'>Other organizations</p>
        <p className='legenda-item shared'>Shared</p>
      </div>
    </div>
  );
}